import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, IconButton, Tooltip } from '@mui/material';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import DeleteIcon from '@mui/icons-material/Delete';
import AskDialog from '../dialog/AskDialog';

const ProfileUpload = ({ uploadProfileImage, removeProfileImage, hasImage }) => {
  // 프로필 이미지 삭제 확인 - window.confirm 대신 화면 안에서 확인(데스크톱/폰 공통)
  const [removeVisible, setRemoveVisible] = useState(false);

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop: (files) => onDropHandler(files),
    multiple: false,
    maxSize: 1000000000,
  });

  const onDropHandler = (files) => {
    //setProfileImg(files[0]);
    uploadProfileImage(files[0]);
  };

  const onConfirmRemove = () => {
    setRemoveVisible(false);
    removeProfileImage();
  };

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 1,
          mt: 1,
        }}
      >
        {/** DropZone */}
        <Box
          sx={{
            display: 'flex',
            alignContent: 'center',
            justifyContent: 'center',
            alignItems: 'center',
            border: 1,
            borderColor: 'grey.500',
            flexGrow: 1,
          }}
          {...getRootProps()}
        >
          <input {...getInputProps()} />
          <PhotoCamera fontSize="large" />
        </Box>
        {hasImage && (
          <Tooltip title="프로필 이미지 삭제">
            <IconButton
              color="error"
              size="small"
              onClick={() => setRemoveVisible(true)}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        )}
      </Box>
      <AskDialog
        visible={removeVisible}
        title="프로필 이미지 삭제"
        description="프로필 이미지를 삭제하시겠습니까?"
        confirmText="삭제"
        onConfirm={onConfirmRemove}
        onCancle={() => setRemoveVisible(false)}
      />
    </>
  );
};
export default ProfileUpload;
